import { Link } from "react-router-dom";
import Loader from "../../components/atoms/Loader";
import Table, { TableColumn } from "../../components/atoms/Table";
import TimeHelper from "../../helpers/TimeHelper";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import { getMultiSectionBatchInfo } from "../MultiSectionBatchesDetailPage/Detail/getMultiSectionBatchInfo";
import { useMultiSectionBatchHistories } from "./useMultiSectionBatchHistories";

const STATUS_LABELS: Record<string, string> = {
  standby: "待機中",
  processing: "処理中",
  success: "成功",
  failure: "失敗",
};

export const HistoryTab = () => {
  const {
    histories,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
  } = useMultiSectionBatchHistories();
  useQueryError(error);

  useOnMainScrollAreaScroll(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage]);

  if (isLoading) {
    return <Loader loading={isLoading} />;
  }

  return (
    <div className="mt-7 flex flex-col gap-4">
      <Table
        headers={[
          { text: "アカウント名", centering: true },
          { text: "操作", centering: true },
          { text: "ステータス", centering: true },
          { text: "開始", centering: true },
          { text: "完了", centering: true },
          { text: "", centering: true },
        ]}
        rows={histories.map((history) => (
          <tr key={history.id}>
            <TableColumn centering>{history.operator.fullName}</TableColumn>
            <TableColumn centering>
              {getMultiSectionBatchInfo(history.batchType).batchTypeHuman}
            </TableColumn>
            <TableColumn
              centering
              className={
                history.status === "failure" ? "text-red-400" : undefined
              }
            >
              {STATUS_LABELS[history.status] ?? history.status}
            </TableColumn>
            <TableColumn centering>
              {history.startedAt
                ? TimeHelper.fullFormat(history.startedAt)
                : ""}
            </TableColumn>
            <TableColumn centering>
              {history.endedAt ? TimeHelper.fullFormat(history.endedAt) : ""}
            </TableColumn>
            <TableColumn centering>
              <Link
                to={`/multi_section_batches/${history.id}`}
                className="text-blue-400 hover:underline"
              >
                詳細
              </Link>
            </TableColumn>
          </tr>
        ))}
        noRowsText="操作履歴がありません"
      />
      <Loader loading={isFetchingNextPage} />
    </div>
  );
};
